export const setGroupByForkanban = (group, key) => {

    let groups = localStorage.getItem("kanbangroupby");

    let setgroups = {}

    if (groups) {

        let parsegroupfromstringify = JSON.parse(groups);
        setgroups = {
            ...parsegroupfromstringify,
            [key]:group
        }

    } else {

        setgroups = {
            [key]: group
        }

    }
    let groupstringify = JSON.stringify(setgroups)
    localStorage.setItem("kanbangroupby", groupstringify)

}

export const getGroupForKanban = (key) => {
    const getgroupsstring = localStorage.getItem("kanbangroupby");

    if (getgroupsstring) {
        try {
            const parsegroup = JSON.parse(getgroupsstring);
            const value = parsegroup[key];

            // Check if the key exists AND if the value is a non-empty object
            if (value && typeof value === "object" && Object.keys(value).length === 0) {
                return null; // it's an empty object
            }

            return value ?? null; // return value if not undefined, else null
        } catch (e) {
            console.error("Invalid JSON in localStorage for 'kanbangroupby'");
            return null;
        }
    }

    return null;
}
